import { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
const SearchableSelect = ({
  options,
  placeholder = "Select an option",
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selected, setSelected] = useState(null);
  const ref = useRef(null);
  const ssp_role = Cookies.get("ssp_role");
  const filteredOptions = options.filter((loc) => {
    const searched_loaction = searchTerm.trim().toLowerCase();
    return (
      loc?.loc?.toString()?.includes(searched_loaction) ||
      loc?.loc_name?.toLowerCase().includes(searched_loaction)
    );
  });
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (opt) => {
    setSelected(opt);
    setIsOpen(false);
    setSearchTerm("");
    onChange && onChange(opt);
  };

  return (
    <div ref={ref} className="relative searchableSelect">
      {/* Display input */}
      <button
        disabled={ssp_role !== "18"}
        onClick={() => setIsOpen(!isOpen)}
        className="w-full border border-gray-300 rounded-md px-3 py-2 text-left bg-white focus:outline-none focus:ring-1 focus:ring-[#FA4B16] disabled:bg-gray-400">
        {selected ? `${selected.loc} : ${selected.loc_name}` : placeholder}
      </button>

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute z-10 mt-1 w-full p-2 bg-white rounded-md shadow-lg">
          {/* Search box */}
          <div className="p-2 ">
            <input
              autoFocus
              type="text"
              placeholder="Search..."
              className="w-full p-2  rounded focus:outline-none focus:ring-1 focus:ring-[#FA4B16]"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* Options */}
          <div className="max-h-72 flex flex-col gap-2 overflow-y-auto">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((elem, index) => (
                <div
                  key={index}
                  className="p-2 hover:bg-indigo-50 cursor-pointer w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FA4B16] transition-colors duration-200 bg-gray-50"
                  onClick={() => {
                    handleSelect(elem);
                  }}>
                  <span className="font-medium text-[#FA4B16]">{elem.loc}</span>{" "}
                  - {elem.loc_name}
                </div>
              ))
            ) : (
              <div className="px-3 py-2 text-gray-500 text-center">
                No results
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
